import moment from 'moment';
import { getBusinessDateStartLocal } from '../../timeline/utils/timeline-dates';

const SHORT_DATE_FORMAT = 'MMM D, YYYY';

export const formatShortBusinessDate = (instantUtc: string): string =>
    moment(getBusinessDateStartLocal(instantUtc)).format(SHORT_DATE_FORMAT);

export const getEarliestSelectableDate = (
    earliestClosingDate?: string | null
): Date => {
    const today = moment().startOf('day').toDate();
    if (!earliestClosingDate) {
        return today;
    }
    const earliest = getBusinessDateStartLocal(earliestClosingDate);
    return earliest > today ? earliest : today;
};

export const isBusinessDateBefore = (
    date: Date | string | null | undefined,
    limitUtc?: string | null
): boolean => {
    if (!date || !limitUtc) {
        return false;
    }
    const dateStart =
        typeof date === 'string'
            ? getBusinessDateStartLocal(date)
            : moment(date).startOf('day').toDate();
    return dateStart < getBusinessDateStartLocal(limitUtc);
};
